import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import womens from "../images/womens_wear.jpg";
import menswear from "../images/mens.jpg";
import Beautyfashion from "../images/accesseroes_lifestyle.jpg";
import Accessories from "../images/accessories.jpg";
import kidswear from "../images/kids_wear.jpg";
import ScrollToTop from "react-scroll-to-top";
import ReactWhatsapp from "react-whatsapp";
import fashionbethuadahari from "../images/Untitled-69 copy.jpg";
import newcollectioncloth from "../images/Untitled-74 copy.jpg";
import collectionclothnew from "../images/Untitled-75 copy.jpg";
import eidgarment from "../images/Untitled-76 copy.jpg";

import megafashion from "../images/Mega _fashion.jpg";
import newsaree from "../images/Saree_collection.jpg";
import weddingcollection from '../images/Wedding _Clothes.jpg';
import kidssummer from "../images/summer_collection Bethuadahari.jpg";


import "./Home.css";
import YoutubeVideo from './YoutubeVideo';
import FacebookPage from './FacebookPage';
import Mapg from './Mapg';
import Slider2 from '../inc/Slider2';
import Videohtml from './Videohtml';
import Homeslide from '../inc/Homeslide';
import KidsFrock from './KidsFrock';
import Winter2026 from './Winter2026';

function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />

      <ScrollToTop smooth top="100" color="maroon" />
      <div className="album py-4">
        <div className="container">
          <h5>Siddeswari Bastralaya</h5>
        </div>
      </div>

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">
              <Slider />
            </div>
            <div className="col-md-4 mt-3">
              <Homeslide />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "2px" }} className="fixed-bottom  mb-1"> <ReactWhatsapp number="+91 9832223839" className="circleb" message="I want to shop at Siddheshwari Bastralay."> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
      </svg>   </ReactWhatsapp></div>
      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='womens-wear'>
                    <div className="card" >
                      <img src={womens} className="card-img-top" alt="womens_wear" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Womens Wear</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="womens-wear" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='mens-wear'>
                    <div className="card" >
                      <img src={menswear} className="card-img-top" alt="menswear" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Mens Wear</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="mens-wear" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='kids-wear'>
                    <div className="card" >
                      <img src={kidswear} className="card-img-top" alt="Siddheswari Bastralaya" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Kids Wear</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="kids-wear" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-md-6 mt-3">
                  <div className="card" >
                    <img src={Beautyfashion} className="card-img-top" alt="Beautyfashion" />
                    <div className="card-body">
                      <h5 className="card-title mb-1">Beauty Care</h5>
                      <p className="card-text">Best High demand products</p>
                      <a href="#" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                </div>
              </div>

            </div>




          </div>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-3">
              <a href='Accessories'>
                <div className="card">
                  <img src={Accessories} className="card-img-top" alt="Accessories" />
                  <div className="card-body">
                    <h5 className="card-title mb-1">Accessories</h5>
                    <p className="card-text">Best High demand products</p>
                    <a href="Accessories" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
              </a>


            </div>
          </div>
        </div>
      </div>
      <br />
<div className='album py-0'>
        <div className="container ">
      <h2 style={{color:"grey"}}><b>Winter Collection 2026 | Warm • Stylish • Elegant</b></h2>
      </div>
      </div>
      <Winter2026/>
      <div className='album py-0'>
        <div className="container ">
          <div className="colorh1">
            <h1 clasName="mb-1" >Siddheswari Bastralaya</h1>
          </div>
          <h5 style={{ color: "grey" }}>Trending Products</h5>

        </div>
      </div>
      <Videohtml />
      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={megafashion} className="card-img-top" alt="megafashion" />
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={newsaree} className="card-img-top" alt="newsaree_Collection" />
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={weddingcollection} className="card-img-top" alt="weddingcollection" />
              </div>
            </div>
             <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={kidssummer} className="card-img-top" alt="summer-collection"/>
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={newcollectioncloth} className="card-img-top" alt="newcollectioncloth" />
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={collectionclothnew} className="card-img-top" alt="newcollectioncloth" />
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={eidgarment} className="card-img-top" alt="eidgarment_bethua" />
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="card" >
                <img src={fashionbethuadahari} className="card-img-top" alt="fashionbethuadahari" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsiddheswaribastralaya&tabs=timeline&width=1000&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="600"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            </div>
            <div className="col-md-6 mt-3">
             <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fsiddheswari.bastralaya.2025%2Fvideos%2F1490364308624825%2F&show_text=true&width=267&t=0" width="100%" height="600"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>

            </div>
          </div>
        </div>
      </div>



      <YoutubeVideo />
      <br />



      <div className="album py-1">
        <div className="container">
          <div className="row">


            <div className="col-md-6 mt-3">
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      SIDDHESWARI BASTRALAYA BETHUADAHARI
                    </button>
                  </h2>
                  <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p style={{ color: "maroon" }} className="card-text mb-1">Patulighat Road, Bethuadahari, Nadia, West Bengal </p>
                      <p style={{ color: "maroon" }} className="card-text mb-1">   Pin 741126, India</p>
                      <a href='https://g.co/kgs/6jyE5nc' target="_blank" rel="noopener noreferrer">
                        <p class='mb-2' >Direction <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-turn-right" viewBox="0 0 16 16">
                          <path d="M5 8.5A2.5 2.5 0 0 1 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658A.25.25 0 0 1 9 8.466V7H7.5A1.5 1.5 0 0 0 6 8.5V11H5z" />
                          <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z" />
                        </svg></p>
                      </a>

                      <a class="appbuttonmanmohinicall me-1" href="tel: 9339704703">+91 9339704703 </a>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      SIDDHESWARI BASTRALAYA BARNIA
                    </button>
                  </h2>
                  <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p style={{ color: "maroon" }} class="card-text mb-1">Barnia, Nadia, Pin-741156, WB</p>
                      <p style={{ color: "maroon" }} class="card-text mb-1">  India</p>
                      <a href='https://g.co/kgs/AaaD4Q3' target="_blank" rel="noopener noreferrer">
                        <p class='mb-2' >Direction <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-turn-right" viewBox="0 0 16 16">
                          <path d="M5 8.5A2.5 2.5 0 0 1 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658A.25.25 0 0 1 9 8.466V7H7.5A1.5 1.5 0 0 0 6 8.5V11H5z" />
                          <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z" />
                        </svg></p>
                      </a>
                      <a class="appbuttonmanmohinicall me-1" href="tel: 7501148974">+91 7501148974 </a>
                    </div>
                  </div>
                </div>



              </div>

            </div>
            <div className="col-md-6 mt-3">
              <Slider2 />
            </div>
          </div>
        </div>
      </div>
      <br/>
<KidsFrock/>

      <br />
    </div>
  )
}

export default Home